import { Link } from 'legacy/lut/components/shared/Link'
import sanitizeHtml from 'sanitize-html'

import { TAdditionalData } from 'onboarding/classes/services/api/OnboardingTransitionApi'

import styles from './ExecuteTransitionByTokenPage.module.scss'

interface IProps {
  success: boolean
  message: string
  additionalData: TAdditionalData
}

const getUrlToRequest = (requestId: number) =>
  `${location.origin}/page/request-detail/rid/${requestId}`
const getUrlToAction = (requestId: number, actionId: number) =>
  `${getUrlToRequest(requestId)}/EntryId/${actionId}`

export const ResultTemplate = ({ success, message, additionalData }: IProps) => {
  const renderSeeActionDetails =
    additionalData.requestId && additionalData.actionId ? (
      <span>
        (
        <Link
          href={sanitizeHtml(getUrlToAction(additionalData.requestId, additionalData.actionId))}
          target={'_blank'}
          color={'primary'}
          className={styles.link}
          rel={'noopener'}
        >
          see details
        </Link>
        )
      </span>
    ) : null

  return (
    <div className={styles.resultContainer}>
      {additionalData.requestId ? (
        <div>
          <b>Case ID</b>:{' '}
          <Link
            href={sanitizeHtml(getUrlToRequest(additionalData.requestId))}
            target={'_blank'}
            color={'primary'}
            className={styles.link}
            rel={'noopener'}
          >
            {additionalData.requestId}
          </Link>
        </div>
      ) : null}

      <div className={styles.resultRowWrapper}>{message}</div>

      {additionalData.actionStatus ? (
        <div className={styles.resultRowWrapper}>
          {success ? 'Action status is switched to' : 'Action status:'}{' '}
          <b>{additionalData.actionStatus}</b> {renderSeeActionDetails}
        </div>
      ) : null}
    </div>
  )
}
